import { useTranslation } from "react-i18next";
import { IconButton, Tooltip, SvgIcon, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePopover } from "@hooks/shared/use-popover";
import { LanguagePopover } from "@components/shared/elements/language-popover";
import { faLanguage } from "@fortawesome/pro-light-svg-icons";

export const LanguageSwitch = () => {
  const popover = usePopover();
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <Tooltip title={t("common.language")}>
        <IconButton
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
          data-testid="language-switch"
          sx={{
            backgroundColor: popover.open
              ? alpha(theme.palette.text.primary, 0.1)
              : "transparent",
            color: popover.open ? theme.palette.text.primary : undefined,
          }}
        >
          <SvgIcon>
            <FontAwesomeIcon icon={faLanguage} />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <LanguagePopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
